// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import EuroTwoToneSvg from "@fishx/icons-svg/es/asn/EuroTwoTone";
import FishxIcon from '../components/FishxIcon';

var EuroTwoTone = function EuroTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: EuroTwoToneSvg
  }));
};

EuroTwoTone.displayName = 'EuroTwoTone';
export default React.forwardRef(EuroTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/EuroTwoTone.js
// module id = 2617
// module chunks = 0